import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import Button from 'modules/_shared/components/Buttons';
import { useShareDetailsPage } from '../context/ShareDetailsPageContext';

const EncumbrancesHeader: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useShareDetailsPage();

  return (
    <div className="encumbrances-header">
      <div>
        <h2 className="encumbrances-header__title">{t('Encumbrances')}</h2>
        <p className="encumbrances-header__subtitle">
          {`${t('HasEncumbrances', {
            count: data.encumbrancesTotal,
          })}`}
        </p>
      </div>
      <Button onClick={actions.handleAddEncumbrance} disabled={data.isReadOnly}>
        <em className="icon ni ni-plus" />
        <span>{t('AddEncumbrance')}</span>
      </Button>
    </div>
  );
};

export default EncumbrancesHeader;
